import { ReceiveItem } from 'src/features/transfers/TransfersTypes'
import * as S from './ReceiveItemMovement.styles'
import TextLabel from '../TextLabel/TextLabel'
import { Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import ReceiveItemBatchesTable from '../ReceiveItemBatchesTable/ReceiveItemBatchesTable'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import ModalUnfitGondola from '../ModalUnfitGondola/ModalUnfitGondola'
import { useDispatch } from 'react-redux'
import { actions } from '../../../TransfersState'
import { toast } from 'react-toastify'

interface ReceiveItemMovementProps {
  badge: string
  idCage: number
  item: ReceiveItem
  startedAt: Date
}

const ReceiveItemMovement = ({
  badge,
  idCage,
  item,
  startedAt,
}: ReceiveItemMovementProps) => {
  const [showModalFitConfirmation, setShowModalFitConfirmation] = useState(false)
  const [showModalUnfitConfirmation, setShowModalUnfitConfirmation] = useState(false)
  const [showModalUnfitGondola, setShowModalUnfitGondola] = useState(false)

  const [preventDoubleClick, setPreventDoubleClick] = useState(false)

  const dispatch = useDispatch()

  const data = useMemo(() => {
    if (item.isGondola) {
      return {
        text: 'DIRETO GÔNDOLA',
        addressTextColor: '#fff',
        addressBackgroundColor: '#000',
      }
    }
    return {
      text: 'REPOSIÇÃO DE EXCEDENTE',
      addressTextColor: '#000',
      addressBackgroundColor: '#fff',
    }
  }, [item])

  const onFitConfirm = () => {
    if (preventDoubleClick) {
      return
    }

    setPreventDoubleClick(true)

    const onSuccess = () => {
      setPreventDoubleClick(false)
      setShowModalFitConfirmation(false)
      toast.success('Movimentação realizada!')
    }

    const onError = () => {
      setPreventDoubleClick(false)
    }

    dispatch(actions.receiveMovement({
      badge,
      idCage,
      item,
      startedAt,
      onSuccess,
      onError,
    }))
  }

  const onUnfit = () => {
    if (item.isGondola) {
      setShowModalUnfitGondola(true)
    } else {
      setShowModalUnfitConfirmation(true)
    }
  }

  const onUnfitConfirm = () => {
    if (preventDoubleClick) {
      return
    }

    setPreventDoubleClick(true)

    const onSuccess = () => {
      setPreventDoubleClick(false)
      setShowModalFitConfirmation(false)
      toast.info('Produto definido para outra localização!')
    }

    const onError = () => {
      setPreventDoubleClick(false)
    }

    dispatch(actions.receiveUnfitMovement({
      badge,
      item,
      startedAt,
      onSuccess,
      onError,
    }))
  }

  return (
    <>
      <S.Container>
        <S.ContainerItem>
          <S.ContainerInfo>
            <S.ContainerType style={{ backgroundColor: data.addressBackgroundColor }}>
              <Typography color={data.addressTextColor} fontWeight='bold'>{data.text}</Typography>
              <S.ContainerBox>
                <TextLabel width='100%' backgroundColor='#FBEF3C'>
                  <Typography fontWeight='bold'>{item.bestPosition.address}</Typography>
                </TextLabel>
              </S.ContainerBox>
            </S.ContainerType>
          </S.ContainerInfo>
          <S.ContainerBox>
            <TextLabel width='100%' height='3.5rem' backgroundColor='#7feb77'>
              <Typography fontSize='14px' fontWeight='bold'>{item.productDescription}</Typography>
            </TextLabel>
          </S.ContainerBox>
          <S.ContainerBox>
            <TextLabel width='100%' backgroundColor='#fff'>
              <Typography fontWeight='bold'>{item.batches.reduce((acc, batch) => acc + batch.quantity, 0)} UNIDADES</Typography>
            </TextLabel>
          </S.ContainerBox>
          <ReceiveItemBatchesTable batches={item.batches} />
        </S.ContainerItem>
        <S.ContainerButtons>
          <S.CustomButton
            title='Não coube'
            type='button'
            bgColor='orange2'
            hoverColor='orange'
            letterColor='white'
            data-testid='unfit-button-test-id'
            onClick={onUnfit}
          />
          <S.CustomButton
            title='Coube tudo'
            type='button'
            bgColor='confirm'
            hoverColor='confirmHover'
            letterColor='white'
            data-testid='fit-button-test-id'
            onClick={() => setShowModalFitConfirmation(true)}
          />
        </S.ContainerButtons>
      </S.Container>
      <ConfirmOrRejectModal
        show={showModalFitConfirmation}
        title={data.text}
        dataTestId='modal-confirmation-fit-test-id'
        customizableDescription={(
          <S.ConfirmModalContainer>
            <S.ConfirmModalText>
              Ao confirmar a ação, você garante que todas as unidades foram devidamente movidas.
            </S.ConfirmModalText>
            <S.ConfirmModalConfirmationText>
              Deseja prosseguir?
            </S.ConfirmModalConfirmationText>
          </S.ConfirmModalContainer>
        )}
        onClose={() => setShowModalFitConfirmation(false)}
        onReject={() => setShowModalFitConfirmation(false)}
        onConfirm={onFitConfirm}
      />
      <ConfirmOrRejectModal
        show={showModalUnfitConfirmation}
        title={data.text}
        dataTestId='modal-confirmation-unfit-test-id'
        customizableDescription={(
          <S.ConfirmModalContainer>
            <S.ConfirmModalText>
              Ao confirmar a ação, <span style={{ fontWeight: 'bold' }}>TODAS</span> as unidades deverão ser movidas para uma nova posição.
            </S.ConfirmModalText>
            <S.ConfirmModalConfirmationText>
              Deseja prosseguir?
            </S.ConfirmModalConfirmationText>
          </S.ConfirmModalContainer>
        )}
        onClose={() => setShowModalUnfitConfirmation(false)}
        onReject={() => setShowModalUnfitConfirmation(false)}
        onConfirm={onUnfitConfirm}
      />
      <ModalUnfitGondola
        badge={badge}
        show={showModalUnfitGondola}
        closeModal={() => setShowModalUnfitGondola(false)}
        item={item}
        startedAt={startedAt}
      />
    </>
  )
}

export default ReceiveItemMovement
